<ng-container *ngIf="loading">
  <div class="table-loader-overlay table-overlay-margin">
    <div class="overlay-spinner-container">
      <mat-spinner color="primary" diameter="75"></mat-spinner>
    </div>
  </div>
</ng-container>

<div class="flex-table upper-space">
  <div class="flex-header-row">
    <div class="flex-4 flex-table-cell">
      Telefoonnummer
    </div>
    <div class="flex-2 flex-table-cell">
      Stand./cust.
    </div>
    <div class="flex-1-25 flex-table-cell">
      Hoogte
    </div>
    <div class="flex-1 flex-table-cell"></div>
    <div class="flex-3 flex-table-cell">Breedte</div>
    <div class="flex-3 flex-table-cell">Tekst</div>
    <div class="flex-3 flex-table-cell">Fond</div>
    <div class="flex-2 flex-table-cell">Ontwerp</div>
    <div class="flex-3 flex-table-cell">Voorraad</div>
    <div class="flex-2 flex-table-cell">Betalend</div>
    <div class="flex-2 flex-table-cell">Prijs</div>
    <div class="flex-1-5 flex-table-cell">Grafisch</div>
    <div class="flex-1 flex-table-cell">Admin</div>
    <div class="flex-2 flex-table-cell"></div>
  </div>
  <div *ngFor="let item of signPhoneNumberAdjustments" class="flex-table-row">
    <div class="flex-4 flex-table-cell" matTooltip="{{ item.phoneNumber }}">
      {{ item.phoneNumber | shortenText: 30 }}
    </div>
    <div class="flex-2 flex-table-cell">
      {{ item.standard | formatBoolean: false:'Standaard':'Custom' }}
    </div>
    <div class="flex-1-25 flex-table-cell">{{ item.height | or }} cm H</div>
    <div class="flex-1 flex-table-cell center">x</div>
    <div class="flex-3 flex-table-cell">{{ item.width | or }} cm B</div>
    <div class="flex-3 flex-table-cell">
      {{ item.textColor }}
    </div>
    <div class="flex-3 flex-table-cell">
      {{ item.foundationColor }}
    </div>
    <div class="flex-2 flex-table-cell">
      <ng-container *ngIf="item.examples?.length > 0">
        <img
          [ngClass]="first ? '' : 'hidden'"
          width="30px"
          height="30px"
          [src]="'/api/assets/' + item.examples[0].asset.uuid + '/30'"
          (click)="openLightbox(item.examples)"
        />
      </ng-container>
    </div>
    <div class="flex-3 flex-table-cell">
      {{ item.inStock | formatBoolean: false }}
    </div>
    <div class="flex-2 flex-table-cell">
      {{ item.charge?.value | formatBoolean: false }}
    </div>
    <div class="flex-2 flex-table-cell">
      €
      {{
        item.charge?.value
          ? (item.charge?.price | asFormatDecimal: false:0)
          : ''
      }}
    </div>
    <div class="flex-1-5 flex-table-cell">
      <mat-icon
        *ngIf="item.graphicsComplete"
        class="fa-2x check-color graphics-complete-translate"
        >check</mat-icon
      >
      <mat-icon
        *ngIf="!item.graphicsComplete"
        class="fa-2x warning-color graphics-complete-translate"
        >report_problem</mat-icon
      >
    </div>
    <div class="flex-1 flex-table-cell">
      <mat-icon
        *ngIf="item.adminComplete"
        class="fa-2x check-color graphics-complete-translate"
        >check</mat-icon
      >
      <mat-icon
        *ngIf="!item.adminComplete"
        class="fa-2x warning-color graphics-complete-translate"
        >report_problem</mat-icon
      >
    </div>
    <div class="flex-table-cell flex-2">
      <div class="d-flex">
        <mat-icon
          svgIcon="edit"
          class="clickable"
          (click)="editItem(item)"
        ></mat-icon>
        <mat-icon
          svgIcon="close"
          class="left-space clickable"
          (click)="deleteItem(item)"
        ></mat-icon>
      </div>
    </div>
  </div>
</div>
<div class="upper-space">
  <mat-icon svgIcon="add" class="clickable" (click)="addItem()"></mat-icon>
</div>
